import { proxy } from "valtio";
import type { OrgUser } from "@services/permissions/commands/cmdListOrgUsers";
import type { Role } from "@services/permissions/commands/cmdListRoles";

interface OrganizationUsersState {
  organizationId: number | null;
  users: OrgUser[];
  roles: Role[];
  isLoading: boolean;
  hasLoaded: boolean;
  isSaving: boolean;
  error: string | null;
}

export const organizationUsersStore = proxy<OrganizationUsersState>({
  organizationId: null,
  users: [],
  roles: [],
  isLoading: false,
  hasLoaded: false,
  isSaving: false,
  error: null,
});

export function resetOrganizationUsersStore() {
  organizationUsersStore.organizationId = null;
  organizationUsersStore.users = [];
  organizationUsersStore.roles = [];
  organizationUsersStore.isLoading = false;
  organizationUsersStore.hasLoaded = false;
  organizationUsersStore.isSaving = false;
  organizationUsersStore.error = null;
}
